import React from 'react';

const DataTableHeader = (props) => {
    if (!props.hasDivider) {
        return (
            <React.Fragment>
                <th width={props.cellWidth ? props.cellWidth : ''} className="cell header-cell">
                    {props.header}
                </th>
            </React.Fragment>
        );
    }

    return (
        <React.Fragment>
            <th width={props.cellWidth ? props.cellWidth : ''} className="cell header-cell">
                {props.header}
            </th>
            <th className="divider"></th>
            <th className="divider left-border"></th>
        </React.Fragment>
    );
};

export default DataTableHeader;
